export function generateUniqueId(): string {
    const timestamp: number = Date.now();
    const randomNum: number = Math.floor(Math.random() * 10000);
    return `${timestamp}-${randomNum}`;
}

export function generateUniqueNumberId(): number {
  return  Math.floor(Math.random() * 100000);
}
